// extracted by mini-css-extract-plugin
export default {"cropped-text":"cropped-text--3G10vjiJhq","croppedText":"cropped-text--3G10vjiJhq","whole":"whole--EkCERIo1YX","front":"front--63ne3dyitK","back":"back--ENF0U6uJ3v"};